import { AnalysisHeader as Component } from './components/AnalysisHeader';
import Connector from './connector';

export const AnalysisHeader = () => <Connector component={Component} />;
